import MiniGameScene from "./MiniGameScene";

//assets
import cloudGameAtlasPNG from "../../../assets/atlas/cloudGame.png";
import cloudGameAtlasJSON from "../../../assets/atlas/cloudGame.json";

import { shuffleArrayFY } from "../../plugins/utils/Utils";

import { PHShape } from "../../plugins/global/PlaceholderPlugin";
import { Physics } from "phaser";

export default class CloudCatcherScene extends MiniGameScene {
  private leftFanButton: Phaser.GameObjects.Image;
  private rightFanButton: Phaser.GameObjects.Image;
  private leftFan: Phaser.GameObjects.Image;
  private rightFan: Phaser.GameObjects.Image;
  private cloud: Phaser.GameObjects.Image;
  private leftFanON: boolean;
  private rightFanON: boolean;
  private itemGroup: Phaser.Physics.Arcade.Group;
  private itemTypes: { key: string; type: number }[];
  private cursors: Phaser.Types.Input.Keyboard.CursorKeys;
  private targetItemRef: number;
  private numCollected: number;
  private targetTotal: number;
  private currentPick: number;
  private taskTargetText: Phaser.GameObjects.Text;
  private itemSpeed: number;
  private cloudSpeed: number;
  private gamePaused: boolean;

  private leftDotsContainer: Phaser.GameObjects.Container;
  private rightDotsContainer: Phaser.GameObjects.Container;

  private leftPower: number = 0;
  private rightPower: number = 0;
  private spawnCount: number = 0;
  private baddieLimit: number;

  private ended: boolean = false;

  constructor() {
    super({
      key: "CloudCatcherScene",
      active: false,
    });
    console.log("CloudCatcherScene::constructor");
  }

  preload(): void {
    //
    super.preload();
    // this.cameras.main.setPipeline();
    this.sponge.placeholder.image(
      this,
      this.cameras.main.centerX,
      this.cameras.main.centerY,
      PHShape.RECT,
      {
        width: this.cameras.main.width,
        height: this.cameras.main.height,
        radius: 0,
      },
      0x2b2a7d
    );

    this.load.atlas("cloudGame", cloudGameAtlasPNG, cloudGameAtlasJSON);
    //this.model =
  }

  create(): void {
    super.create();
    console.log("CloudCatcherScene::create");
    this.add.image(0, 0, "cloudGame", "cloudBg.png").setOrigin(0);

    this.cloud = this.physics.add
      .image(360, 336, "cloudGame", "cloud.png")
      .setBounceX(0.05);

    this.itemSpeed = 180;
    this.cloudSpeed = 180;
    this.gamePaused = false;
    this.spawnCount = 0;
    this.baddieLimit = Phaser.Math.RND.between(20, 30);

    //instead of instatiating items and adding to group we can use the group config to auto create only the objects we need, setting in active will allow it to be re-used.
    this.itemGroup = this.physics.add.group({
      defaultKey: "cloudGame",
      defaultFrame: "vidItem.png",
      collideWorldBounds: true,
      maxSize: 50,
      createCallback: (go: Phaser.GameObjects.Sprite) => {
        go.setData("hitCloud", false).setAlpha(0);
        (go.body as Phaser.Physics.Arcade.Body).setCircle(48, 34, 34);
      },
    });

    //for when we spawn items we want to chose a random item (but cycle through the items)
    this.itemTypes = shuffleArrayFY([
      { key: "vidItem.png", type: 0 },
      { key: "gameItem.png", type: 1 },
      { key: "picItem.png", type: 2 },
    ]);

    this.targetTotal = this.baddieLimit - Phaser.Math.RND.between(2, 5);
    this.targetItemRef = Phaser.Math.RND.between(0, 2);
    this.numCollected = 0;
    this.currentPick = 0;

    this.physics.add.overlap(
      this.cloud,
      this.itemGroup,
      this.checkItemOverlap,
      null,
      this
    );

    //powerLines
    this.add.image(18, 292, "cloudGame", "pipe.png").setOrigin(0);
    this.add
      .image(this.cameras.main.width - 222, 292, "cloudGame", "pipe.png")
      .setOrigin(0)
      .setFlipX(true);

    //power dots
    this.leftDotsContainer = this.add.container(62, 520);
    this.rightDotsContainer = this.add.container(
      this.cameras.main.width - 61,
      520
    );
    for (let i: number = 0; i < 5; i++) {
      const pipL = this.add.image(0, 120 * i, "cloudGame", "bead.png");
      this.leftDotsContainer.add(pipL);
      const pipR = this.add.image(0, 120 * i, "cloudGame", "bead.png");
      this.rightDotsContainer.add(pipR);
    }

    //fans
    this.leftFanON = false;
    this.rightFanON = false;

    //this.fanGroup = this.physics.add.staticGroup();
    const fanL = this.physics.add
      .image(62, 336, "cloudGame", "fanBg.png")
      .setBodySize(120, 120);
    const fanR = this.physics.add
      .image(this.cameras.main.width - 62, 336, "cloudGame", "fanBg.png")
      .setBodySize(120, 120);
    //this.fanGroup.addMultiple([fanL,fanR]);
    fanL.body.immovable = true;
    fanR.body.immovable = true;

    this.physics.add.collider(this.cloud, fanL);
    this.physics.add.collider(this.cloud, fanR);

    this.leftFan = this.add.image(62, 336, "cloudGame", "fanBlade.png");
    this.rightFan = this.add.image(
      this.cameras.main.width - 62,
      336,
      "cloudGame",
      "fanBlade.png"
    );
    const leftAir = this.add
      .image(112, 336, "cloudGame", "airLines.png")
      .setOrigin(0, 0.5)
      .setScale(0, 1);
    const rightAir = this.add
      .image(this.cameras.main.width - 112, 336, "cloudGame", "airLines.png")
      .setOrigin(1, 0.5)
      .setFlipX(true)
      .setScale(0, 1);
    this.leftFan.setData("wind", leftAir);
    this.rightFan.setData("wind", rightAir);

    //buttons
    this.leftFanButton = this.add.image(200, 1170, "fanButton");
    this.leftFanButton.setInteractive();
    this.leftFanButton.on("pointerdown", this.startLeftFan, this);
    this.leftFanButton.on("pointerup", this.stopLeftFan, this);

    this.rightFanButton = this.add
      .image(520, 1170, "fanButton")
      .setScale(-1, 1);
    this.rightFanButton.setInteractive();
    this.rightFanButton.on("pointerdown", this.startRightFan, this);
    this.rightFanButton.on("pointerup", this.stopRightFan, this);

    this.cursors = this.input.keyboard.createCursorKeys();

    const header = this.add.graphics();
    header.fillStyle(0x000624, 1);
    header.fillRect(0, 0, 720, 166);

    // set up target amount display
    const taskTitle = this.add
      .text(320, 235, "Collect:", this.sponge.data.model.fonts.button)
      .setOrigin(1, 0.5);
    const icons = ["vidItem.png", "gameItem.png", "picItem.png"];
    for (let i: number = 0; i < 3; i++) {
      const taskIcon = this.add
        .image(350 + 50 * i, 235, "cloudGame", icons[i])
        .setScale(0.5);
    }

    this.taskTargetText = this.add
      .text(
        490,
        235,
        "x " + this.targetTotal,
        this.sponge.data.model.fonts.button
      )
      .setOrigin(0, 0.5);

    this.physics.world.on("worldbounds", this.onWorldBounds);
  }

  start() {
    console.log("cloud catcher start!");
    this.ended = false;
    this.spawnItem();
  }

  //update to play to launch all baddies at once
  spawnBaddies() {
    if (this.ended) {
      return;
    }

    const spawnX = [180, 300, 420, 540];
    //{ key: "enemyItem.png", type: 3 },
    for (let i: number = 0; i < 4; i++) {
      const baddie = this.itemGroup.get();

      baddie
        .setFrame("enemyItem.png")
        .setData("type", 3)
        .setPosition(spawnX[i], 1100)
        .setActive(true)
        .setVisible(true);

      baddie.setVelocityY(-this.itemSpeed);
      baddie.data.values.hitCloud = false;
      this.tweens.add({
        targets: baddie,
        alpha: 1,
        duration: 350,
        ease: "Quad.easeOut",
      });
      this.tweens.add({
        targets: baddie,
        scale: 1.1,
        duration: 350,
        ease: "Quad.easeOut",
        yoyo: true,
        repeat: -1,
      });
    }

    console.log("SPAWN BADDIES");
    this.spawnCount++;
    if (this.spawnCount < 5) {
      this.time.addEvent({
        delay: 750,
        callbackScope: this,
        callback: this.spawnBaddies,
      });
    }
  }

  spawnItem() {
    if (this.ended) {
      return;
    }

    if (!this.gamePaused) {
      this.spawnCount++;

      if (this.spawnCount >= this.baddieLimit) {
        console.log(
          "SPAWN BADDIES THRESHOLD REACHED:",
          this.baddieLimit,
          this.spawnCount
        );
        this.spawnCount = 0;
        this.spawnBaddies();
        return;
      }

      const spawnX = [180, 300, 420, 540];
      const spawnTwo: boolean =
        Phaser.Math.RND.between(0, 20) > 15 ? true : false;

      const spawn = this.itemGroup.get();

      if(spawn !== null){
      //TODO set itemType
      const type = this.itemTypes[this.currentPick % 3];
      this.currentPick++;

      spawn
        .setFrame(type.key)
        .setData("type", type.type)
        .setPosition(
          spawnTwo
            ? spawnX[Phaser.Math.RND.between(0, 1)]
            : spawnX[Phaser.Math.RND.between(0, 3)],
          1100
        )
        .setActive(true)
        .setVisible(true);

      spawn.setVelocityY(-this.itemSpeed);
      spawn.data.values.hitCloud = false;
      this.tweens.add({
        targets: spawn,
        alpha: 1,
        duration: 350,
        ease: "Quad.easeOut",
      });
    }

      if (spawnTwo) {
        const spawn2 = this.itemGroup.get();

        if(spawn2 !== null){

        //TODO set itemType
        const type = this.itemTypes[this.currentPick % 3];
        this.currentPick++;
        spawn2
          .setFrame(type.key)
          .setData("type", type.type)
          .setPosition(spawnX[Phaser.Math.RND.between(2, 3)], 1100)
          .setActive(true)
          .setVisible(true);
        spawn2.setVelocityY(-this.itemSpeed);
        spawn2.data.values.hitCloud = false;
        this.tweens.add({
          targets: spawn2,
          alpha: 1,
          duration: 350,
          ease: "Quad.easeOut",
        });
      }
    }
    }

    this.time.addEvent({
      delay: 750,
      callbackScope: this,
      callback: this.spawnItem,
    });
  }

  onWorldBounds(body: Physics.Arcade.Body) {
    const item = body.gameObject;
    item.setActive(false);
  }

  pauseAllActions() {
    console.log("pause minigame sprites:CLoud");
    this.gamePaused = true;
    this.itemGroup.children.each(function (item: Physics.Arcade.Image) {
      item.setVelocityY(0);
    }, this);
  }

  resumeAllActions() {
    console.log("resume minigame sprites:CLoud");
    this.gamePaused = false;
    this.itemGroup.children.each(function (item: Physics.Arcade.Image) {
      item.setVelocityY(-this.itemSpeed);
    }, this);

    super.resumeAllActions();
  }

  checkItemOverlap(
    cloud: Phaser.Physics.Arcade.Sprite,
    item: Phaser.Physics.Arcade.Image
  ) {
    //
    if (!item.data.values.hitCloud) {
      item.data.values.hitCloud = true;
      console.log(item.data.values.type);
      if (item.data.values.type === 3) {
        //hit enemy - so lose?
        this.ended = true;
        this.itemGroup.setVelocityY(0).setVisible(false);
        this.showFeedback(false);
      } else {
        this.numCollected++;
        this.taskTargetText.setText(
          "x " + (this.targetTotal - this.numCollected)
        );
        console.log("collected the right one:", this.targetItemRef);
        if (this.numCollected >= this.targetTotal) {
          this.collectedAllItems();
        }
      }

      this.tweens.add({
        targets: item,
        alpha: 0,
        duration: 250,
        ease: "Quad.easeIn",
      });
    }

    item.setActive(false);
  }

  collectedAllItems() {
    console.log("got them all");
    this.ended = true;
    this.itemGroup.setVelocityY(0).setVisible(false);
    this.showFeedback(true);
  }

  startLeftFan() {
    this.leftFanButton.setFrame(1);
    this.leftFanON = true;
  }
  stopLeftFan() {
    this.leftFanButton.setFrame(0);
    this.leftFanON = false;
  }

  startRightFan() {
    this.rightFanButton.setFrame(1);
    this.rightFanON = true;
  }
  stopRightFan() {
    this.rightFanButton.setFrame(0);
    this.rightFanON = false;
  }

  showFeedback(success: boolean) {
    switch (success) {
      case true:
        // show Positive feedback from model
        this.complete(1);
        this.shutdown();
        break;
      default:
        // show Negative feedback from model
        this.complete(0);
        this.shutdown();
        break;
    }
  }

  checkItemYPos(item: Physics.Arcade.Image) {
    if (!item.data.values.hitCloud && item.y < 320) {
      console.log("HIDE ITEM!");
      item.data.values.hitCloud = true;
      // item.setActive(false);
      this.tweens.add({
        targets: item,
        alpha: 0,
        duration: 250,
        ease: "Quad.easeIn",
        onComplete: () => {
          item.setActive(false);
          item.setVisible(false);
        },
      });
    }
  }

  update(time: number, delta: number): void {
    //

    this.itemGroup.children.each(this.checkItemYPos, this);

    if (!this.gamePaused) {
      if (this.leftFanON || this.cursors.right.isDown) {
        if (this.leftPower < 1) {
          this.leftPower += 0.05;
        }

        if (this.leftPower >= 1) {
          this.leftPower = 1;
          // will do cloud movement with physics!
          this.cloud.body.velocity.x = this.cloudSpeed;
          this.leftFan.angle += 10;
          this.leftFan.data.values.wind.scaleX =
            this.leftFan.data.values.wind.scaleX < 1
              ? (this.leftFan.data.values.wind.scaleX += 0.25)
              : 1;
        }
      } else {
        if (this.leftPower > 0) {
          this.leftPower -= 0.025;
          this.leftFan.data.values.wind.scaleX =
            this.leftFan.data.values.wind.scaleX > 0
              ? (this.leftFan.data.values.wind.scaleX -= 0.25)
              : 0;
          this.cloud.body.velocity.x =
            this.cloud.body.velocity.x > 0
              ? (this.cloud.body.velocity.x -= 10)
              : 0;
          this.leftFan.angle += this.leftPower * 10;
        }
      }

      if (this.rightFanON || this.cursors.left.isDown) {
        if (this.rightPower < 1) {
          this.rightPower += 0.05;
        }

        if (this.rightPower >= 1) {
          this.rightPower = 1;
          // will do cloud movement with physics!
          this.cloud.body.velocity.x = -this.cloudSpeed;
          this.rightFan.angle += 10;
          this.rightFan.data.values.wind.scaleX =
            this.rightFan.data.values.wind.scaleX < 1
              ? (this.rightFan.data.values.wind.scaleX += 0.25)
              : 1;
        }
      } else {
        if (this.rightPower > 0) {
          this.rightPower -= 0.025;
          this.rightFan.data.values.wind.scaleX =
            this.rightFan.data.values.wind.scaleX > 0
              ? (this.rightFan.data.values.wind.scaleX -= 0.25)
              : 0;
          this.cloud.body.velocity.x =
            this.cloud.body.velocity.x < 0
              ? (this.cloud.body.velocity.x += 10)
              : 0;
          this.rightFan.angle += this.rightPower * 10;
        }
      }
    }

    const dotsL: Phaser.GameObjects.Image[] = this.leftDotsContainer.getAll() as Phaser.GameObjects.Image[];

    //for each dot in group set alpha based in the progress the electricity is
    for (let i = 0; i < dotsL.length; i++) {
      dotsL[i].alpha = 1 - i / dotsL.length > this.leftPower ? 0 : 1;
    }
    const dotsR: Phaser.GameObjects.Image[] = this.rightDotsContainer.getAll() as Phaser.GameObjects.Image[];
    //right side
    for (let i = 0; i < dotsR.length; i++) {
      dotsR[i].alpha = 1 - i / dotsR.length > this.rightPower ? 0 : 1;
    }
  }

  render() {
    this.itemGroup;
  }

  shutdown(): void {
    //call our minigame complete method
    super.shutdown();
  }
}
